// src/api/assessmentApi.js
import axiosClient from "./axiosClient";

//Get all assessment types
export const getAssessmentTypes = async () => {
  const res = await axiosClient.get("/assessment-types/");
  return res.data;
};

export const getAssessmentTypesForSettings = async () => {
  const res = await axiosClient.get("/assessment-types/manage/");
  return res.data?.results || [];
};

export const createAssessmentType = async (data) => {
  const res = await axiosClient.post("/assessment-types/manage/", data);
  return res.data;
};

export const updateAssessmentType = async (typeId, data) => {
  const res = await axiosClient.put(`/assessment-types/${typeId}/update/`, data);
  return res.data;
};

//Create a new assessment
export const createAssessment = async (data) => {
  return axiosClient.post("/assessments/create/", data);
};

//Update an existing assessment
export const updateAssessment = async (assessmentId, data) => {
  return axiosClient.put(`/assessments/${assessmentId}/update/`, data);
};

//Fetch details for a property or unit (used for editing)
export const getAssessmentParentDetails = async (propertyId, unitId) => {
  const endpoint = unitId
    ? `/units/${unitId}/details/`
    : `/properties/${propertyId}/details/`;
  const res = await axiosClient.get(endpoint);
  return res.data;
};

export const getAssessmentsPage = async ({ propertyId, unitId, page = 1, pageSize = 10 }) => {
  const endpoint = unitId
    ? `/units/${unitId}/assessments/`
    : `/properties/${propertyId}/assessments/`;
  const res = await axiosClient.get(endpoint, {
    params: {
      page,
      page_size: pageSize,
    },
  });
  return res.data;
};

export const deleteAssessment = async (assessmentId) => {
    return axiosClient.delete(`/assessments/${assessmentId}/delete/`);
};
